"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var client = axios_1.default.create({
    headers: {
        requesttoken: OC.requestToken
    }
});
exports.default = client;
